import http from "../http-common";

class ExpertB2BService {
  getAllB2BExperts(token: any, search?: any, expertise?: any, expert?: any) {
    return http.get(
      `/expertsb2b?search=${search}&expertise=${expertise}&expert=${expert}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getB2BExpert(id: string) {
    return http.get(`/expertsb2b/${id}`);
  }

  addB2BExpert(token: any, expertData: any) {
    return http.post("/expertsb2b/add", expertData, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  updateB2BExpert(id: string, expertData: any) {
    return http.patch(`/expertsb2b/${id}/update`, expertData);
  }

  deleteB2BExpert(id: string) {
    return http.delete(`/expertsb2b/${id}`);
  }

  downloadB2BExpertInvoice(id: string, month: string, year: string) {
    return http.get(
      `/expertsb2b/${id}/pdf/download?month=${month}&year=${year}`
    );
  }

  sendB2BExpertInvoiceEmail(id: string, month: string, year: string) {
    return http.get(`/expertsb2b/${id}/send-email?month=${month}&year=${year}`);
  }

  downloadB2BExpertsBillingSheet(
    month: string,
    year: string,
    payment_status?: string,
    status?: string
  ) {
    return http.get(
      `/expertsb2b/billing-sheet/download?month=${month}&year=${year}&payment_status=${payment_status}&status=${status}`,
      { responseType: "blob" }
    );
  }

  updateRating(id: string, rating: any) {
    return http.patch(`/expertsb2b/${id}/rating`, { rating });
  }

  addEditNote(id: string, noteData: any) {
    return http.patch(`/expertsb2b/${id}/note`, noteData);
  }

  deleteNote(id: string) {
    return http.delete(`/expertsb2b/${id}/note`);
  }
}

export default new ExpertB2BService();
